import useAirportLookup, { TravelPayoutAutocompleteResult } from '../../hooks/useAirportLookup'
import React, { ChangeEventHandler, FC, useEffect, useState } from 'react'

interface Props {
  initialAirportName?: string
  placeholder?: string
  className?: string
  handleAirportSelected: (result: TravelPayoutAutocompleteResult) => void
}

const AirportLookup: FC<Props> = ({
  initialAirportName = '',
  placeholder = 'Choose Airport',
  className,
  handleAirportSelected,
}) => {
  const [searchQuery, setSearchQuery] = useState(initialAirportName)
  const [showAirportSearchResults, setShowAirportSearchResults] = useState(false)

  useEffect(() => {
    setSearchQuery(initialAirportName)
    setShowAirportSearchResults(false)
  }, [initialAirportName])

  const handleAirportSearchInput: ChangeEventHandler<HTMLInputElement> = (event) => {
    setShowAirportSearchResults(true)
    setSearchQuery(event.target.value)
  }

  const { results, getAirportName } = useAirportLookup(searchQuery, showAirportSearchResults)

  const onClick = (result: TravelPayoutAutocompleteResult) => {
    setShowAirportSearchResults(false)
    setSearchQuery(getAirportName(result))
    handleAirportSelected(result)
  }

  return (
    <div className={className}>
      <input
        type="text"
        className="form-control form-control-lg"
        placeholder={placeholder}
        value={searchQuery}
        onChange={handleAirportSearchInput}
      />
      {showAirportSearchResults && results.length > 0 && (
        <div className="airport-results-wrap position-absolute bg-white d-flex flex-column w-100 z-index-9 py-3">
          {results.map((result: TravelPayoutAutocompleteResult) => (
            <span className="px-3 py-1" key={result.id} onClick={() => onClick(result)}>
              {getAirportName(result)} ({result.code})
            </span>
          ))}
        </div>
      )}
    </div>
  )
}

export default AirportLookup
